import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserNotificationChannel } from '@model';
import { environment } from 'environments/environment';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationSettingsService {

  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  GetMyNotificationChannels(): Observable<UserNotificationChannel[]> {
    return this.http
      .get<UserNotificationChannel[]>(`${environment.apiEndpoint}/UserNotificationChannels`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  UpdateMyNotificationChannels(notificationChannels: UserNotificationChannel[]): Observable<UserNotificationChannel[]> {
    return this.http
      .post<UserNotificationChannel[]>(`${environment.apiEndpoint}/UserNotificationChannels`, notificationChannels)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  UpdateMyNotificationChannel(notificationChannel: UserNotificationChannel): Observable<UserNotificationChannel> {
    return this.http
      .post<UserNotificationChannel>(`${environment.apiEndpoint}/UserNotificationChannels/${notificationChannel.id}`, notificationChannel)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
